import React, {useState, useEffect, useRef, useMemo} from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { InputTextarea } from 'primereact/inputtextarea';
import { TabPanel, TabView } from "primereact/tabview";
import './BitacorasTaller.scss';
import {
    addMaintenanceLog, cancelMaintenanceLog,
    getExistingLogbook, getMaintenanceLogs,
    getProvider,
    getServiceTypes,
    getTrazo,
    getUnits, updateMaintenanceLog, verificar
} from "./BitacorasTaller.Integracion";
import Map from "../../../components/molecules/Map/Map";
import { Marker, Popup } from "react-leaflet";
import {
    combinarFechaYHora,
    formatearFechaHora,
    formatOnlyDate,
} from "../../../utilidades/formateos";
import Swal from "sweetalert2";
import MapFlyToProveedor from "../../../components/molecules/Map/MapFly";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { UpdateValue } from "../../../utilidades/Validaciones";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import ServiceDialog from "./components/ServiceDialog";
import { Dialog } from "primereact/dialog";
import { MapContainer, Circle, Tooltip, Polyline } from "react-leaflet";
import BaseMapLayer from "../../../components/molecules/Map/BaseMapLayer";
import markerIcon from '../../../assets/icons/marker.png';
import marker_confirmacion from '../../../assets/icons/confirmado.png';
import marker_apertura from '../../../assets/icons/open.png';
import marker_verde_apertura from '../../../assets/icons/marker_verde_apertura.png';
import markerInicio from '../../../assets/icons/start.png';
import marker_finalizar from '../../../assets/icons/stop-circled.png';
import marker_final_ruta from '../../../assets/icons/apagar.png';
import marker_final_ruta_verde from '../../../assets/icons/marker_final_ruta_verde.png';
import marker_taller from '../../../assets/icons/car-service.png';
import L from 'leaflet';
import {Toast} from "primereact/toast";
import {desEncriptar} from "../../../utilidades/encriptacion";
const BitacorasTaller = () => {
    const DEFAULT_CENTER = [20.67129241646564, -103.35232101509537];

    // Medianoche de hoy. Se usa como mínimo para "Fecha de Bitácora":
    // si se pasa `new Date()` directo, arrastra la hora actual y PrimeReact
    // reemplaza la selección de "hoy" por ese instante (que en el siguiente
    // render ya quedó en el pasado), dejando el campo -y las horas- en blanco.
    const inicioDeHoy = useMemo(() => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }, []);

    const esMismoDia = (a, b) =>
        a instanceof Date && b instanceof Date &&
        !isNaN(a) && !isNaN(b) &&
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

    const [dateFilters, setDateFilters] = useState({
        start: { value: new Date(new Date().getFullYear(), new Date().getMonth(), 1) },
        end: { value: new Date() }
    });

    const session = JSON.parse(
        desEncriptar(
            sessionStorage.getItem("dataClient"),
            process.env.REACT_APP_CLAVE_INCRIPTACION
        )
    );

    const [formData, setFormData] = useState({
        fechaCaptura: new Date(),
        fechaBitacora: '',
        horaEntrada: '',
        horaSalida: '',
        tipo: '',
        unidad: '',
        proveedorTaller: '',
        nota: ''
    });

    const [unidades, setUnidades] = useState([]);
    const [tiposServicio, setTiposServicio] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [selectedProveedor, setSelectedProveedor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [services, setServices] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [mapDialogVisible, setMapDialogVisible] = useState(false);
    const [mapData, setMapData] = useState(null);
    const [showTrazo, setShowTrazo] = useState(false);
    const [trazoData, setTrazoData] = useState(null);
    const [hoverInfo, setHoverInfo] = useState(null); // { latlng: LatLng, hora: string }
    const [dialogData, setDialogData] = useState(null);
    const [verificarVisible, setVerificarVisible] = useState(null);
    const toast = useRef(null);

    const [operadorInfo, setOperadorInfo] = useState({
        nombre: '',
        telefono: ''
    });

    // Iconos para los markers
    const defaultMarker = new L.Icon({
        iconUrl: markerIcon,
        iconSize: [20, 20],
        iconAnchor: [10, 10],
        popupAnchor: [10, 10],
    });
    // Iconos de alta calidad SVG para cada tipo de evento (iconos8)
    const icons = {
        confirmacion: new L.Icon({
            iconUrl: marker_confirmacion,
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
        apertura: new L.Icon({
            iconUrl: marker_apertura, // clock
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
        inicioRutaVerde: new L.Icon({
            iconUrl: marker_verde_apertura, // start/flag
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
        inicioRutaRojo: new L.Icon({
            iconUrl: markerInicio, // alert
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
        finRutaVerde: new L.Icon({
            iconUrl: marker_final_ruta_verde, // finish flag
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
        finRutaRojo: new L.Icon({
            iconUrl: marker_final_ruta, // cancel
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
        cierre: new L.Icon({
            iconUrl: marker_finalizar, // close/cross
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
        taller: new L.Icon({
            iconUrl: marker_taller, // wrench/tools
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [20, 20],
        }),
    };
    // Función para calcular distancia entre dos puntos lat/lon en metros
    function getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2) {
        if (
            typeof lat1 !== "number" || typeof lon1 !== "number" ||
            typeof lat2 !== "number" || typeof lon2 !== "number"
        ) return Infinity;
        const R = 6371000; // Radio de la tierra en metros
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    useEffect(() => {
        getMaintenanceLogs(dateFilters).then((data) => {
            setServices(data)
        }).catch((error) => {
            console.log(error)
        })
    }, [dateFilters]);

    useEffect(() => {
        getUnits().then(data => setUnidades(data));
        getServiceTypes().then(serv => setTiposServicio(serv));
        getProvider().then(prov => setProveedores(prov));
    }, []);

    // Efecto para actualizar información del operador
    useEffect(() => {
        if (formData.unidad) {
            const unidadSeleccionada = unidades.find(u => u.value === formData.unidad);
            if (unidadSeleccionada) {
                setOperadorInfo({
                    nombre: unidadSeleccionada.operador,
                    telefono: unidadSeleccionada.telefono
                });
                setFormData(prev => ({
                    ...prev,
                    operador: unidadSeleccionada.id_op,
                }));
            }

            if (selectedProveedor) {
                setFormData(prev => ({
                    ...prev,
                    direccion: { lat: selectedProveedor.lat, lng: selectedProveedor.lng }
                }));
            }
        } else {
            setOperadorInfo({ nombre: '', telefono: '' });
        }
    }, [formData.unidad, selectedProveedor])


    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };


    const handleSubmit = async () => {
        setLoading(true);

        try {
            // Validar que no se registre una bitácora en una hora que ya pasó.
            // Se permite para hoy, siempre que la hora de entrada sea futura.
            const ahora = new Date();
            const entrada = new Date(formData.horaEntrada);
            const salida = new Date(formData.horaSalida);

            if (isNaN(entrada) || isNaN(salida)) {
                await Swal.fire('Datos incompletos', 'Selecciona la fecha y las horas de la bitácora.', 'warning');
                return;
            }
            if (esMismoDia(entrada, ahora) && entrada < ahora) {
                await Swal.fire('Hora inválida', 'No puedes crear una bitácora en una hora que ya pasó.', 'warning');
                return;
            }
            if (salida <= entrada) {
                await Swal.fire('Hora inválida', 'La hora de salida debe ser posterior a la hora de entrada.', 'warning');
                return;
            }

            // Verificar si existe conflicto de horario
            const existeConflicto = await getExistingLogbook(formData);

            // Si hay conflicto, pedir confirmación al usuario
            if (existeConflicto) {
                const result = await Swal.fire({
                    title: 'Conflicto de horario detectado',
                    text: 'Ya existe una bitácora que interfiere con el horario asignado. ¿Deseas continuar con el registro?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí, continuar',
                    cancelButtonText: 'Cancelar'
                });

                // Si el usuario cancela, salir de la función
                if (!result.isConfirmed) {
                    return;
                }
            }

            // Registrar la bitácora (se ejecuta si no hay conflicto o si el usuario confirmó)
            const userId = session?.user?.ID;

            const payload = {
                ...formData,
                usuario: userId
            };
            await addMaintenanceLog(payload);

            // Éxito: mostrar mensaje, resetear formulario y recargar datos
            await Swal.fire('Bitácora registrada correctamente', '', 'success');
            handleReset();
            // Recargar datos solo después del éxito
            const data = await getMaintenanceLogs(dateFilters);
            setServices(data);

        } catch (error) {
            // Determinar el tipo de error y mostrar mensaje apropiado
            const errorMessage = error.message?.includes('verificar')
                ? 'Error al verificar bitácoras existentes'
                : 'Error al registrar la bitácora';

            const errorDetail = error.message?.includes('verificar')
                ? 'Verifica tu conexión o intenta más tarde.'
                : 'Intenta nuevamente más tarde.';

            await Swal.fire(errorMessage, errorDetail, 'error');

        } finally {
            // Siempre desactivar el loading, sin importar el resultado
            setLoading(false);
        }
    };

    const handleSubmitEdit = async () => {
        setLoading(true);
        try {
            // No permitir dejar la bitácora en una hora que ya pasó (solo aplica si es hoy)
            const ahora = new Date();
            const entrada = new Date(formData.horaEntrada);
            const salida = new Date(formData.horaSalida);

            if (isNaN(entrada) || isNaN(salida)) {
                await Swal.fire('Datos incompletos', 'Selecciona la fecha y las horas de la bitácora.', 'warning');
                return;
            }
            if (esMismoDia(entrada, ahora) && entrada < ahora) {
                await Swal.fire('Hora inválida', 'No puedes dejar la bitácora en una hora que ya pasó.', 'warning');
                return;
            }
            if (salida <= entrada) {
                await Swal.fire('Hora inválida', 'La hora de salida debe ser posterior a la hora de entrada.', 'warning');
                return;
            }

            // Combinar fechaBitacora con las horas originales
            const horaEntradaActualizada = combinarFechaYHora(
                formData.fechaBitacora,
                formData.horaEntrada
            );

            const horaSalidaActualizada = combinarFechaYHora(
                formData.fechaBitacora,
                formData.horaSalida
            );

            // Formatear solo la fecha (sin hora)
            const fechaBitacoraFormateada = formatOnlyDate(formData.fechaBitacora);

            const proveedorCompleto = proveedores.find(p => p.value === formData.proveedorTaller);

            const dataUpdate = {
                ...formData,
                fechaBitacora: fechaBitacoraFormateada,
                horaEntrada: horaEntradaActualizada,
                horaSalida: horaSalidaActualizada,
                direccion: { lat: proveedorCompleto.lat, lng: proveedorCompleto.lng }
            };

            await updateMaintenanceLog(dataUpdate);
            await Swal.fire('Bitácora actualizada correctamente', '', 'success');
            const data = await getMaintenanceLogs(dateFilters);
            setServices(data);
            handleReset();
            setDialogVisible(false);

        } catch (error) {
            console.error('Error al actualizar:', error);
            await Swal.fire('Error al actualizar bitácora', '', 'error');
        } finally {
            setLoading(false);
        }
    };


    const handleReset = () => {
        setFormData({
            fechaCaptura: new Date(),
            fechaBitacora: '',
            horaEntrada: '',
            horaSalida: '',
            tipo: '',
            unidad: '',
            operador: '',
            proveedorTaller: '',
            nota: ''
        });
        setOperadorInfo({ nombre: '', telefono: '' });
    };

    const combineDateAndTime = (datePart, timePart) => {
        if (!datePart || !timePart) return null;

        const combined = new Date(datePart);
        combined.setHours(timePart.getHours());
        combined.setMinutes(timePart.getMinutes());
        combined.setSeconds(0);
        combined.setMilliseconds(0);
        return combined;
    };

    const getSeverity = (status) => {
        switch (status) {
            case 'TERMINADA':
                return 'success';
            case 'EN CURSO':
                return 'info';
            case 'CONFIRMADA':
                return 'primary';
            case 'PROGRAMADA':
                return 'warning';
            case 'CANCELADA':
                return 'danger';
            default:
                return 'secondary';
        }
    };

    const calcularPago = (inicio, fin) => {
        const minutos = Math.floor((fin - inicio) / 60000);
        const horasCompletas = Math.min(Math.floor(minutos / 60), 10);
        const horasExtra = Math.max(horasCompletas - 1, 0);
        let pago = 80 + horasExtra * 20;
        if (horasCompletas >= 6) pago += 50;
        return { pago, horasCompletas, minutos };
    };

    const estatusTemplate = (rowData) => {
        return (
            <Tag
                value={rowData.estatus}
                severity={getSeverity(rowData.estatus)}
            />
        );
    };

    const combineDateWithTime = (fechaStr, timeDate) => {
        if (!fechaStr || !timeDate) return null;

        // fechaStr viene como "14/04/2026"
        const [day, month, year] = fechaStr.split('/');
        const combined = new Date(year, month - 1, day);
        combined.setHours(timeDate.getHours());
        combined.setMinutes(timeDate.getMinutes());
        combined.setSeconds(0);

        // Formato "14-04-2026 10:20:00"
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(combined.getDate())}-${pad(combined.getMonth() + 1)}-${combined.getFullYear()} ${pad(combined.getHours())}:${pad(combined.getMinutes())}:${pad(combined.getSeconds())}`;
    };

    const VerificarDialog = ({ rowData, visible, onHide, onVerificada }) => {
        const parseTime = (timeStr) => {
            if (!timeStr) return null;
            const [h, m, s] = timeStr.split(':').map(Number);
            const d = new Date();
            d.setHours(h, m, s || 0, 0);
            return d;
        };

        const [horaInicio, setHoraInicio] = useState(() => parseTime(rowData?.horaInicio));
        const [horaFin, setHoraFin] = useState(() => parseTime(rowData?.horaFin));
        const [loading, setLoading] = useState(false);

        const preview = horaInicio && horaFin && horaFin > horaInicio
            ? calcularPago(horaInicio, horaFin)
            : null;

        const handleVerificar = async () => {
            setLoading(true);
            try {
                const horaInicioFormateada = combineDateWithTime(rowData.fecha, horaInicio);
                const horaFinFormateada    = combineDateWithTime(rowData.fecha, horaFin);

                const data = await verificar(rowData.id, horaInicioFormateada, horaFinFormateada, preview.pago);
                onVerificada?.(rowData.id, data.pagoChofer);
                toast.current.show({severity:'success', summary: 'Verificado', detail:'Verificación exitosa', life: 3000});
                onHide();
            } catch (err) {
                toast.current.show({severity:'error', summary: 'Error', detail:'No se completo la validación', life: 3000});
            } finally {
                setLoading(false);
            }
        };

        const footer = (
            <div className="flex justify-content-end gap-2">
                <Button label="Cancelar" icon="pi pi-times" text severity="secondary" onClick={onHide} />
                <Button
                    label="Verificar"
                    icon="pi pi-check"
                    disabled={!preview}
                    loading={loading}
                    onClick={handleVerificar}
                />
            </div>
        );

        return (
            <Dialog
                header="Verificar bitácora"
                visible={visible}
                style={{ width: '30rem' }}
                onHide={onHide}
                footer={footer}
            >
                <div className="flex flex-column gap-3">

                    <div className="flex flex-column gap-1">
                        <span className="text-sm text-color-secondary">Operador</span>
                        <span className="font-medium">{rowData?.operador}</span>
                    </div>

                    <div className="flex gap-3">
                        <div className="flex flex-column gap-1">
                            <span className="text-sm text-color-secondary">Unidad</span>
                            <span className="font-medium">{rowData?.unidad}</span>
                        </div>
                        <div className="flex flex-column gap-1">
                            <span className="text-sm text-color-secondary">Fecha</span>
                            <span className="font-medium">{rowData?.fecha}</span>
                        </div>
                    </div>

                    <div className="flex gap-3">
                        <div className="flex flex-column gap-1 flex-1">
                            <label className="text-sm text-color-secondary">Hora inicio</label>
                            <Calendar
                                value={horaInicio}
                                onChange={(e) => setHoraInicio(e.value)}
                                timeOnly
                                showTime
                                hourFormat="24"
                                placeholder="00:00"
                            />
                        </div>
                        <div className="flex flex-column gap-1 flex-1">
                            <label className="text-sm text-color-secondary">Hora fin</label>
                            <Calendar
                                value={horaFin}
                                onChange={(e) => setHoraFin(e.value)}
                                timeOnly
                                showTime
                                hourFormat="24"
                                placeholder="00:00"
                                minDate={horaInicio}
                            />
                        </div>
                    </div>

                    {preview && (
                        <div className="border-round p-3 mt-1" style={{ background: 'var(--highlight-bg)' }}>
                            <div className="flex justify-content-between text-sm mb-1">
                                <span className="text-color-secondary">Horas trabajadas</span>
                                <span>{preview.horasCompletas}h {preview.minutos % 60}min</span>
                            </div>
                            {preview.horasCompletas > 6 && (
                                <div className="flex justify-content-between text-sm mb-1">
                                    <span className="text-color-secondary">Alimentos (+6h)</span>
                                    <span>$50</span>
                                </div>
                            )}
                            <div className="flex justify-content-between font-medium mt-2 pt-2" style={{ borderTop: '1px solid var(--surface-border)' }}>
                                <span>Total a pagar</span>
                                <span>${preview.pago} MXN</span>
                            </div>
                        </div>
                    )}

                </div>
            </Dialog>
        );
    };


    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <IconField iconPosition="right" className="mr-2">
                    <InputIcon className="pi pi-search" />
                    <InputText onChange={(e) => setGlobalFilter(e.target.value)}
                               placeholder="Buscar..." />
                </IconField>
            </React.Fragment>
        );
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <div style={{ display: "flex", flexDirection: "row", gap: '10px' }}>
                    <div className="columna">
                        <Calendar value={dateFilters.start.value}
                                  onChange={(e) => {
                                      UpdateValue(e, "start", dateFilters, setDateFilters)
                                  }} showIcon dateFormat="dd/mm/yy" readOnlyInput={true} />
                    </div>
                    <div className="columna">
                        <Calendar value={dateFilters.end.value}
                                  onChange={(e) => {
                                      UpdateValue(e, "end", dateFilters, setDateFilters)
                                  }} showIcon dateFormat="dd/mm/yy" readOnlyInput={true} />
                    </div>
                </div>
            </>
        )
    }
    const verificadaTemplate = (rowData) => {
        if (rowData.VERIFICADA) {
            return <i className="pi pi-check" style={{ color: 'green', fontSize: '0.8rem' }} title="Verificada" />;
        }

        return (
            <>
                <Button
                    icon="pi pi-check-circle"
                    disabled={rowData.estatus !== 'TERMINADA'}
                    size="small"
                    severity="warning"
                    text
                    tooltip="Verificar bitácora"
                    tooltipOptions={{position: 'left'}}
                    onClick={() => {
                        setDialogData(rowData)
                        setVerificarVisible(true)}
                    } // abre el dialog
                />
            </>
        );
    };

    const cancelButtonTemplate = (rowData) => {
        const isCancelable = !['CANCELADA', 'TERMINADA', 'EN CURSO'].includes(rowData.estatus);

        return isCancelable ? (
            <>
                <div style={{ display: "flex", gap: '10px' }}>

                    <Button
                        icon="pi pi-times"
                        severity="danger"
                        aria-label="Cancelar"
                        tooltip="Cancelar"
                        onClick={() => handleCancel(rowData.id)}
                        style={{ marginRight: '0.5rem' }}
                    />
                    <Button
                        icon="pi pi-pen-to-square"
                        severity="info"
                        aria-label="Editar"
                        tooltip="Editar"
                        onClick={() => handleEdit(rowData)}
                    />
                </div>
            </>

        ) : null;
    };
    function getClosestPoint(mouseLatLng, points) {
        let minDist = Infinity;
        let closestPoint = null;
        for (let point of points) {
            const dist = mouseLatLng.distanceTo(L.latLng(point.lat, point.lng));
            if (dist < minDist) {
                minDist = dist;
                closestPoint = point;
            }
        }
        return closestPoint;
    }
    const handleClose = () => {
        setHoverInfo(null);
    };
    const handleClick = (e) => {
        if (!trazoData.trazo) return;
        const mouseLatLng = e.latlng;
        const closest = getClosestPoint(mouseLatLng, trazoData.trazo);
        if (closest) {
            setHoverInfo({
                latlng: L.latLng(closest.lat, closest.lng),
                hora: ` Hora: ${closest.hora}` || "Hora no disponible",
                velocidad: ` Velocidad: ${closest.velocidad} km/h` || "Velocidad no disponible",
            });
        }
    };
    const handleCancel = (id) => {
        confirmDialog({
            message: `¿Seguro que deseas cancelar la bitácora #${id}?`,
            header: 'Confirmar cancelación',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sí, cancelar',
            rejectLabel: 'No',
            accept: async () => {
                try {
                    const userId = session?.user?.ID;
                    await cancelMaintenanceLog(id, userId);
                    await Swal.fire('Éxito', `Bitácora ${id} cancelada`, 'success');
                    const logs = await getMaintenanceLogs(dateFilters);
                    setServices(logs);
                } catch (error) {
                    await Swal.fire('Error al cancelar la bitácora', 'Intenta nuevamente más tarde.', 'error');
                }
            }
        });
    }

    // Convierte "dd/mm/yyyy" (o "yyyy-mm-dd") + "HH:mm:ss" a un Date local.
    // `new Date("14/04/2026 07:30:00")` devuelve Invalid Date, por eso el
    // diálogo de edición mostraba fecha y horas en blanco.
    const parseFechaLocal = (fechaStr, horaStr) => {
        if (!fechaStr) return null;
        let y, m, d;
        if (fechaStr.includes('/')) {
            [d, m, y] = fechaStr.split('/').map(Number);
        } else {
            [y, m, d] = fechaStr.split('-').map(Number);
        }
        const [hh = 0, mm = 0, ss = 0] = horaStr ? horaStr.split(':').map(Number) : [];
        const fecha = new Date(y, m - 1, d, hh, mm, ss);
        return isNaN(fecha) ? null : fecha;
    };

    // Función para manejar la edición
    const handleEdit = (rowData) => {
        // Cargar los datos del registro en el formulario
        setFormData({
            id: rowData.id,
            fechaBitacora: parseFechaLocal(rowData.fecha),
            tipo: rowData.tipo,
            horaEntrada: parseFechaLocal(rowData.fecha, rowData.horaInicioProgramada),
            horaSalida: parseFechaLocal(rowData.fecha, rowData.horaFinProgramada),
            proveedorTaller: rowData.idProveedor,
            unidad: rowData.unidad,
            nota: rowData.nota
        });

        // Cargar el proveedor seleccionado
        const proveedor = proveedores.find(p => p.value === rowData.proveedorTaller);
        setSelectedProveedor(proveedor);

        // Abrir el diálogo
        setDialogVisible(true);
    };

    // Botón de mapa en la tabla
    const mapButtonTemplate = (rowData) => (
        <Button
            icon="pi pi-map-marker"
            severity="help"
            aria-label="Ver Mapa"
            tooltip="Ver Mapa"
            onClick={() => {
                setMapData(rowData);
                setMapDialogVisible(true);
                setShowTrazo(false); // Reset trazo al abrir
            }}
            style={{ marginRight: '0.5rem' }}
        />
    );

    const mostrarTrazo = async () => {
        try {
            setLoading(true);
            await getTrazo(mapData?.id, setTrazoData);
            setShowTrazo(true);
        } catch (error) {
            console.error("Error al obtener el trazo:", error);
            await Swal.fire('Error', 'No se pudo cargar el trazo de la ruta', 'error');
        } finally {
            setLoading(false);
        }
    }


    /**
     * Formateador de moneda MXN
     */
    const currencyFormatter = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
    });

    /**
     * Template para columna de pago
     */
    const pagoOperadorTemplate = (rowData) => {
        const value = Number(rowData.PAGO_CHOFER) || 0;
        return currencyFormatter.format(value);
    };

    return (
        <div className="maintenance-panel">
            <Toast ref={toast} />
            <ConfirmDialog />
            <TabView>
                <TabPanel header="Listado de Bitacoras" leftIcon="pi pi-list icon-r">
                    <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                    <DataTable
                        value={services}
                        dataKey="id"
                        size={'small'}
                        paginator
                        rows={20}
                        rowsPerPageOptions={[20, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} bitacoras"
                        globalFilter={globalFilter}
                        header="Bitacoras"
                        responsiveLayout="scroll"
                        scrollable scrollHeight="calc(-340px + 100vh)"
                        style={{ fontSize: '0.8rem' }}
                    >
                        <Column field="id" header="ID" sortable style={{ width: '5rem' }} />
                        <Column field="estatus" header="Estatus" body={estatusTemplate} sortable style={{ width: '10rem' }} />
                        <Column field="unidad" header="Unidad" sortable style={{ width: '8rem' }} />
                        <Column field="operador" header="Operador" sortable style={{ width: '14rem' }} />
                        <Column field="fecha" header="Fecha" sortable style={{ width: '8rem' }} />
                        <Column field="horaInicioProgramada" header="Inicio Programado" sortable style={{ width: '10rem', textAlign: 'start' }} />
                        <Column field="horaFinProgramada" header="Fin Programado" sortable style={{ width: '10rem', textAlign: 'start' }} />
                        <Column field="taller" header="Taller" sortable style={{ width: '12rem' }} />
                        <Column field="horaInicio" header="Hora Inicio"
                                body={(rowData) => rowData.horaInicio ? rowData.horaInicio : 'SIN REGISTRO'}
                                style={{ width: '10rem' }} />
                        <Column field="horaFin" header="Hora Fin"
                                body={(rowData) => rowData.horaFin ? rowData.horaFin : 'SIN REGISTRO'}
                                style={{ width: '10rem' }} />
                        <Column field="duracion" header="Duración" sortable style={{ width: '12rem' }} />
                        <Column
                            field="PAGO_CHOFER"
                            header="Pago Operador"
                            sortable
                            body={pagoOperadorTemplate}
                            style={{ width: '8rem' }}
                        />
                        <Column field="VERIFICADA" header="Verificada" body={verificadaTemplate} style={{ width: '12rem' }} />
                        <Column
                            header="Mapa"
                            body={mapButtonTemplate}
                            style={{ width: '5rem', textAlign: 'center' }}
                        />
                        <Column header="Acciones" body={cancelButtonTemplate} style={{ width: '10rem' }} />
                    </DataTable>
                    {/* Modal del mapa */}
                    <Dialog
                        header="Ubicaciones de la Bitácora"
                        visible={mapDialogVisible}
                        style={{ width: '50vw' }}
                        onHide={() => {
                            setMapDialogVisible(false);
                            setShowTrazo(false);
                        }}
                        maximizable
                        modal
                    >
                        {mapData && (
                            <>
                                <div className='botonMostrarTrazo'>
                                    <Button
                                        label={showTrazo ? "Ocultar Trazo" : "Mostrar Trazo"}
                                        icon={showTrazo ? "pi pi-eye-slash" : "pi pi-map"}
                                        onClick={() => {
                                            if (showTrazo) {
                                                setShowTrazo(false);
                                                setTrazoData(null);
                                            } else {
                                                mostrarTrazo();
                                            }
                                        }}
                                        severity={showTrazo ? "secondary" : "info"}
                                        size="small"
                                        loading={loading}
                                    />
                                </div>
                                <MapContainer
                                    center={[
                                        mapData.LAT_TALLER || DEFAULT_CENTER[0],
                                        mapData.LON_TALLER || DEFAULT_CENTER[1]
                                    ]}
                                    zoom={15}
                                    style={{ height: "400px", width: "100%" }}
                                >
                                    <BaseMapLayer />
                                    {/* Geocerca de 100m en el taller */}
                                    {mapData.LAT_TALLER && mapData.LON_TALLER && (() => {
                                        // Convierte a número por si vienen como string
                                        const latTaller = Number(mapData.LAT_TALLER);
                                        const lonTaller = Number(mapData.LON_TALLER);
                                        const latInicio = Number(mapData.LAT_INICIO_RUTA);
                                        const lonInicio = Number(mapData.LON_INICIO_RUTA);
                                        const latFin = Number(mapData.LAT_FIN_RUTA);
                                        const lonFin = Number(mapData.LON_FIN_RUTA);

                                        const inicioExiste = !isNaN(latInicio) && !isNaN(lonInicio);
                                        const finExiste = !isNaN(latFin) && !isNaN(lonFin);

                                        let color = 'blue';
                                        if (inicioExiste && finExiste) {
                                            const inicioDentro = getDistanceFromLatLonInMeters(
                                                latInicio, lonInicio,
                                                latTaller, lonTaller
                                            ) <= 100;
                                            const finDentro = getDistanceFromLatLonInMeters(
                                                latFin, lonFin,
                                                latTaller, lonTaller
                                            ) <= 100;
                                            if (inicioDentro && finDentro) {
                                                color = 'green';
                                            }
                                            // Puedes quitar los logs si ya no los necesitas
                                            // console.log("inicioDentro",inicioDentro);
                                            // console.log("finDentro",finDentro);
                                        }
                                        return (
                                            <Circle
                                                center={[latTaller, lonTaller]}
                                                radius={100}
                                                pathOptions={{
                                                    color: color,
                                                    fillColor: color,
                                                    fillOpacity: 0.2
                                                }}
                                            />
                                        );
                                    })()}
                                    {/* Trazo desde el servidor */}
                                    {showTrazo && trazoData?.trazo && trazoData.trazo.length > 0 && (
                                        <Polyline
                                            positions={trazoData.trazo.map(punto => [punto.lat, punto.lng])}
                                            pathOptions={{
                                                color: '#0f3f75ff',
                                                weight: 3,
                                                opacity: 1

                                            }}
                                            eventHandlers={{
                                                click: handleClick,
                                            }}
                                        />
                                    )}
                                    {hoverInfo && (
                                        <Popup
                                            position={hoverInfo.latlng}
                                            autoPan={false}
                                            closeButton={true}
                                            onClose={handleClose}
                                        >
                                            <div style={{ fontWeight: "bold" }}>{hoverInfo.hora}</div>
                                            <div style={{ fontWeight: "bold" }}>{hoverInfo.velocidad}</div>
                                        </Popup>
                                    )}
                                    {/* Markers de paradas (stops) si existen */}
                                    {/* {showTrazo && trazoData?.stops && trazoData.stops.map((stop, index) => (
                                        <Marker
                                            key={`stop-${index}`}
                                            position={[stop.lat, stop.lng]}
                                            icon={defaultMarker}
                                        >
                                            <Tooltip direction="top" offset={[0, -10]} opacity={1}>
                                                Parada {index + 1}
                                            </Tooltip>
                                        </Marker>
                                    ))} */}
                                    {/* Markers para cada coordenada con Tooltip e icono representativo */}
                                    {mapData.LAT_CONFIRMACION && mapData.LON_CONFIRMACION && (
                                        <Marker position={[mapData.LAT_CONFIRMACION, mapData.LON_CONFIRMACION]} icon={icons.confirmacion} >
                                            <Tooltip direction="top" offset={[0, -10]} opacity={1}>Confirmación</Tooltip>
                                        </Marker>
                                    )}
                                    {mapData.LAT_APERTURA && mapData.LON_APERTURA && (
                                        <Marker position={[mapData.LAT_APERTURA, mapData.LON_APERTURA]} icon={icons.apertura} >
                                            <Tooltip direction="top" offset={[0, -10]} opacity={1}>Apertura</Tooltip>
                                        </Marker>
                                    )}
                                    {/* INICIO_RUTA marker con color dinámico e icono */}
                                    {mapData.LAT_INICIO_RUTA && mapData.LON_INICIO_RUTA && mapData.LAT_TALLER && mapData.LON_TALLER && (
                                        <Marker
                                            position={[mapData.LAT_INICIO_RUTA, mapData.LON_INICIO_RUTA]}
                                            icon={
                                                getDistanceFromLatLonInMeters(
                                                    mapData.LAT_INICIO_RUTA, mapData.LON_INICIO_RUTA,
                                                    mapData.LAT_TALLER, mapData.LON_TALLER
                                                ) <= 100 ? icons.inicioRutaVerde : icons.inicioRutaRojo
                                            }
                                        >
                                            <Tooltip direction="top" offset={[0, -10]} opacity={1}>Inicio Ruta</Tooltip>
                                        </Marker>
                                    )}
                                    {/* FIN_RUTA marker con color dinámico e icono */}
                                    {mapData.LAT_FIN_RUTA && mapData.LON_FIN_RUTA && mapData.LAT_TALLER && mapData.LON_TALLER && (
                                        <Marker
                                            position={[mapData.LAT_FIN_RUTA, mapData.LON_FIN_RUTA]}
                                            icon={
                                                getDistanceFromLatLonInMeters(
                                                    mapData.LAT_FIN_RUTA, mapData.LON_FIN_RUTA,
                                                    mapData.LAT_TALLER, mapData.LON_TALLER
                                                ) <= 100 ? icons.finRutaVerde : icons.finRutaRojo
                                            }
                                        >
                                            <Tooltip direction="top" offset={[0, -10]} opacity={1}>Fin Ruta</Tooltip>
                                        </Marker>
                                    )}
                                    {mapData.LAT_CIERRE && mapData.LON_CIERRE && (
                                        <Marker position={[mapData.LAT_CIERRE, mapData.LON_CIERRE]} icon={icons.cierre} >
                                            <Tooltip direction="top" offset={[0, -10]} opacity={1}>Cierre</Tooltip>
                                        </Marker>
                                    )}
                                    {mapData.LAT_TALLER && mapData.LON_TALLER && (
                                        <Marker position={[mapData.LAT_TALLER, mapData.LON_TALLER]} icon={icons.taller} >
                                            <Tooltip direction="top" offset={[0, -10]} opacity={1}>Taller</Tooltip>
                                        </Marker>
                                    )}
                                </MapContainer>
                            </>
                        )}
                    </Dialog>
                </TabPanel>
                <TabPanel header="Nueva Bitacora" leftIcon="pi pi-plus icon-r">
                    <div className="service-form-container">
                        <Card
                            className="service-form-card"
                            pt={{
                                title: {
                                    className: 'service-form-title'
                                }
                            }}
                        >
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}>
                                <div className="form-grid-taller">
                                    <div>
                                        <div className="field-container">
                                            <label className="field-label-taller">
                                                Fecha de Bitácora *
                                            </label>
                                            <Calendar
                                                value={formData.fechaBitacora ? new Date(formData.fechaBitacora) : null}
                                                onChange={(e) =>
                                                    handleInputChange('fechaBitacora', formatearFechaHora(e.value))
                                                }
                                                minDate={inicioDeHoy}
                                                dateFormat="dd/mm/yy"
                                                showIcon
                                                className="form-input"
                                                required
                                            />
                                        </div>

                                        <div className="field-container">
                                            <label className="field-label-taller">
                                                Tipo de Servicio *
                                            </label>
                                            <Dropdown
                                                value={formData.tipo}
                                                options={tiposServicio}
                                                onChange={(e) => handleInputChange('tipo', e.value)}
                                                placeholder="Seleccione el tipo de servicio"
                                                className="form-input"
                                                filter
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="time-grid">
                                            <div>
                                                <label className="field-label-taller">
                                                    Hora Entrada *
                                                </label>
                                                <Calendar
                                                    value={formData.horaEntrada ? new Date(formData.horaEntrada) : null}
                                                    onChange={(e) => {
                                                        const combined = combineDateAndTime(
                                                            formData.fechaBitacora ? new Date(formData.fechaBitacora) : new Date(),
                                                            e.value
                                                        );
                                                        handleInputChange('horaEntrada', formatearFechaHora(combined));
                                                    }}
                                                    timeOnly
                                                    hourFormat="24"
                                                    showIcon
                                                    className="form-input"
                                                    style={{ width: '100%' }}
                                                    minDate={
                                                        esMismoDia(new Date(formData.fechaBitacora), new Date())
                                                            ? new Date()
                                                            : undefined
                                                    }
                                                    disabled={!formData.fechaBitacora}
                                                    required
                                                />
                                            </div>
                                            <div>
                                                <label className="field-label-taller">
                                                    Hora Salida *
                                                </label>
                                                <Calendar
                                                    value={formData.horaSalida ? new Date(formData.horaSalida) : null}
                                                    onChange={(e) => {
                                                        const combined = combineDateAndTime(
                                                            formData.fechaBitacora ? new Date(formData.fechaBitacora) : new Date(),
                                                            e.value
                                                        );
                                                        handleInputChange('horaSalida', formatearFechaHora(combined));
                                                    }}
                                                    timeOnly
                                                    hourFormat="24"
                                                    showIcon
                                                    className="form-input"
                                                    style={{ width: '100%' }}
                                                    minDate={
                                                        formData.horaEntrada
                                                            ? new Date(formData.horaEntrada)
                                                            : (esMismoDia(new Date(formData.fechaBitacora), new Date())
                                                                ? new Date()
                                                                : undefined)
                                                    }
                                                    disabled={!formData.fechaBitacora}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="field-container">
                                            <label className="field-label-taller">
                                                Proveedor de Taller *
                                            </label>
                                            <Dropdown
                                                value={formData.proveedorTaller}
                                                options={proveedores}
                                                onChange={(e) => {
                                                    handleInputChange('proveedorTaller', e.value);
                                                    const proveedorCompleto = proveedores.find(p => p.value === e.value);
                                                    setSelectedProveedor(proveedorCompleto);
                                                }}
                                                placeholder="Seleccione el proveedor"
                                                className="form-input"
                                                filter
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-grid-taller">
                                    <div>
                                        <div className="field-container">
                                            <label className="field-label-taller">
                                                Unidad *
                                            </label>
                                            <Dropdown
                                                value={formData.unidad}
                                                options={unidades}
                                                onChange={(e) => handleInputChange('unidad', e.value)}
                                                placeholder="Seleccione la unidad"
                                                className="form-input"
                                                filter
                                                required
                                            />
                                        </div>

                                        {/* Información del Operador */}
                                        {operadorInfo.nombre && (
                                            <div className="operator-info">
                                                <h4 className="operator-title">
                                                    Información del Operador
                                                </h4>
                                                <p className="operator-detail">
                                                    <strong>Nombre:</strong> {operadorInfo.nombre}
                                                </p>
                                                <p className="operator-detail">
                                                    <strong>Teléfono:</strong> {operadorInfo.telefono}
                                                </p>
                                            </div>
                                        )}

                                    </div>
                                    <div>
                                        <div className="field-container">
                                            <label className="field-label-taller">
                                                Nota
                                            </label>
                                            <InputTextarea
                                                value={formData.nota}
                                                onChange={(e) => handleInputChange('nota', e.target.value)}
                                                placeholder="Notas adicionales..."
                                                rows={3}
                                                className="form-textarea"
                                                pt={{
                                                    root: { className: 'textarea-root' }
                                                }}
                                            />
                                        </div>
                                        {/* Botones */}
                                        <div className="button-container-taller">
                                            <Button
                                                label="Guardar Servicio"
                                                icon="pi pi-save"
                                                type="submit"
                                                className="btn-save"
                                                severity="success"
                                                loading={loading}
                                            />
                                            <Button
                                                label="Limpiar Formulario"
                                                icon="pi pi-refresh"
                                                onClick={handleReset}
                                                className="btn-reset"
                                                severity="secondary"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>


                            <Divider />

                            {/* Mapa Placeholder */}
                            <div className="map-section">
                                <h3 className="section-title">
                                    Mapa de Ubicación del Taller
                                </h3>
                                <div className="map-placeholder">
                                    <Map
                                        center={DEFAULT_CENTER}
                                        zoom={10}
                                        scrollWheelZoom={true}
                                        style={{ width: '100%', height: '30rem', zIndex: "0" }}
                                    >
                                        {selectedProveedor?.lat && selectedProveedor?.lng && (
                                            <>
                                                <Marker position={[selectedProveedor.lat, selectedProveedor.lng]} />
                                                <MapFlyToProveedor lat={selectedProveedor.lat}
                                                                   lng={selectedProveedor.lng} />
                                            </>
                                        )}
                                    </Map>
                                </div>
                            </div>
                        </Card>
                    </div>
                </TabPanel>
            </TabView>
            <ServiceDialog
                visible={dialogVisible}
                onHide={() => {
                    handleReset();
                    setDialogVisible(false);
                }}
                formData={formData}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmitEdit}
                handleReset={handleReset}
                tiposServicio={tiposServicio}
                proveedores={proveedores}
                unidades={unidades}
                operadorInfo={operadorInfo}
                selectedProveedor={selectedProveedor}
                setSelectedProveedor={setSelectedProveedor}
                loading={loading}
                formatearFechaHora={formatearFechaHora}
                combineDateAndTime={combineDateAndTime}
                inicioDeHoy={inicioDeHoy}
                esMismoDia={esMismoDia}
                DEFAULT_CENTER={DEFAULT_CENTER}
                MapFlyToProveedor={MapFlyToProveedor}
            />

            <VerificarDialog
                rowData={dialogData}
                visible={verificarVisible}
                onHide={() => {
                    setDialogData(null);
                    setVerificarVisible(false);
                }}
                onVerificada={(id, pago) => {
                    setServices(prev => prev.map(r =>
                        r.id === id ? { ...r, VERIFICADA: true, PAGO_CHOFER: pago } : r
                    ));
                }}
            />

        </div>

    );
};

export default BitacorasTaller;
